import React, { FC } from "react";
import ReactPlayer from "react-player";
import { getYoutubeThumbnail, getYoutubeUrl } from "@app/helpers";

export interface VideoCardProps {
  title: string;
  excerpt: string;
  youtubeId: string;
  isPlaying: boolean;
  onPlay: () => void;
  onStop: () => void;
}

export const VideoCard: FC<VideoCardProps> = ({
  title,
  excerpt,
  youtubeId,
  isPlaying,
  onPlay,
  onStop,
}) => {
  return (
    <div>
      <div className="relative mb-5">
        <div className="aspect-video">
          <ReactPlayer
            width="100%"
            height="100%"
            light={getYoutubeThumbnail(youtubeId)}
            controls
            playing={isPlaying}
            style={{ objectFit: "cover" }}
            url={getYoutubeUrl(youtubeId)}
            title={title}
            onPlay={onPlay}
            onClickPreview={onPlay}
            onPause={onStop}
            onEnded={onStop}
          />
        </div>
      </div>

      <div>
        <h3 className="text-medium text-primary-content mb-4">{title}</h3>
        <p className="text-regular text-base-400">{excerpt}</p>
      </div>
    </div>
  );
};
